export default __webpack_public_path__ + "static/media/esg-59.9ff176dc.jpg";